import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import SiteHeader from "@/components/site/SiteHeader";
import SiteHero from "@/components/site/SiteHero";
import Fenomeno from "@/components/site/Fenomeno";
import Coste from "@/components/site/Coste";
import MarcoNormativo from "@/components/site/MarcoNormativo";
import PullPush from "@/components/site/PullPush";
import Solucion from "@/components/site/Solucion";
import Privacidad from "@/components/site/Privacidad";
import Operativa from "@/components/site/Operativa";
import Patente from "@/components/site/Patente";
import CalcSection from "@/components/site/CalcSection";
import Contacto from "@/components/site/Contacto";
import SiteFooter from "@/components/site/SiteFooter";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";
import DocumentosPage from "@/pages/DocumentosPage";
import { Toaster } from "@/components/ui/sonner";

function HomePage() {
  return (
    <main>
      <SiteHero />
      <Fenomeno />
      <Coste />
      <MarcoNormativo />
      <PullPush />
      <Solucion />
      <Privacidad />
      <Operativa />
      <Patente />
      <CalcSection />
      <Contacto />
    </main>
  );
}

export default function App() {
  return (
    <div className="min-h-screen bg-cream font-body text-forest-800 antialiased">
      <HelmetProvider>
        <BrowserRouter>
          <SiteHeader />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/documentos" element={<DocumentosPage />} />
          </Routes>
          <SiteFooter />
        </BrowserRouter>
      </HelmetProvider>
      <FloatingWhatsApp />
      <Toaster position="top-center" />
    </div>
  );
}
